import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import TemplateControls from "../../layout/TemplateControls";
import SortableList from "../../layout/SortableList";

const Social = () => {
  const {visible, currentVideoPopup} = useSetting();
  // Without the banners an admin removed (libs/bannerComposition.ts).
  const items = useRouteTemplates("partners");
  const bannerIds = items.map((template) => template.id);
  const hasOnlyOneBanner = bannerIds.length === 1;

  return (
    <SortableList
      items={items}
      useDragHandle={true}
      getItemClassName={(item) =>
        cn("template-wrap", {
          hidden: !hasOnlyOneBanner && !visible.some((x) => x === item.id),
          popup: currentVideoPopup === item.id,
        })
      }
      renderItem={(item, {listeners, attributes} = {}) => (
        <>
          <div
            className="template-annotation"
            {...(listeners || {})}
            {...(attributes || {})}
            style={{cursor: "grab"}}
          >
            <span
              className="label"
              data-tooltip={item.tooltip || null}
            >{`${item.label} (${item.dimensions}${item.suffix || ""})`}</span>
            <TemplateControls
              id={item.id}
              templateChannel="partners"
              hasOnlyOneBanner={hasOnlyOneBanner}
              bannerIds={bannerIds}
            />
          </div>
          {item.getComponent()}
        </>
      )}
    />
  );
};

export default Social;
